<template lang="html">
  <div id="scale-model" class="dn db-ns relative overflow-hidden">
    <div class="flex flex-column h-100">
      <div class="flex-auto h-100 relative">
        <div class="absolute w-100 top-0 z-999">
          <img class="w5 center mt3" src="/static/the_keeley-logo.png" />
        </div>
        <div class="absolute w-100 vh-100 top-0 left-0">
          <div v-show="keyplateShown" class="w-100 vh-100 bg-center bg-green flex items-center justify-center">
            <img :src="kpURL" style="max-height: 70vh" />
          </div>
        <iframe name="model" class="w-100 h-100" src="/static/model/index.html?r=12323" frameborder="0"></iframe>
        </div>
      </div>
    </div>
    <div class="sticky bottom-0 w-100 z-999 pb4 pt3" :class="{ 'bg-green': keyplateShown, 'bg-blue': !keyplateShown }">
      <div v-show="!keyplateShown" class="mb3 pointer hover-action flex items-center justify-center" @click="toggleUnits">
        <i class="material-icons" v-if="!unitsShown">&#xE835;</i>
        <i class="material-icons" v-else>&#xE834;</i>
        <span class="ml1 b">Show Units | {{ availableUnitsByRoute }} available</span>
      </div>
      <div v-if="curRoute === 'FloorplanDetail'"
        class="flex justify-center"
      >
        <v-btn
          @click.native="TOGGLE_KEYPLATE_SHOWN(false)"
          :label="'3D MODEL'"
          class="bg-black raise b white mr2"
        />
        <v-btn
          @click.native="TOGGLE_KEYPLATE_SHOWN(true)"
          :label="'KEYPLAN'"
          class="bg-black raise b white"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ButtonComponent from '@/components/Button';

export default {
  name: 'scale-model',
  components: {
    'v-btn': ButtonComponent
  },
  methods: {
    ...mapActions({
      TOGGLE_KEYPLATE_SHOWN: 'TOGGLE_KEYPLATE_SHOWN',
      SET_UNITS_SHOWN: 'SET_UNITS_SHOWN'
    }),
    toggleUnits() {
      const data = { enabled: !this.unitsShown, curRoute: this.$route.name };
      this.SET_UNITS_SHOWN(data);
    }
  },
  computed: {
    ...mapGetters({
      getKeyplateImg: 'getKeyplateImg',
      keyplateShown: 'getKeyplateShown',
      unitsShown: 'getUnitsShown',
      getActiveFPPage: 'getActiveFPPage',
      availUnits: 'availUnits',
      modelReady: 'getModelReady',
      availUnitsByPlanId: 'availUnitsByPlanId',
      getFloorplanById: 'getFloorplanById'
    }),
    kpURL() {
      return this.getKeyplateImg;
    },
    unitCount() {
      return 0;
    },
    curRoute() {
      return this.$route.name;
    },
    availableUnitsByRoute() {
      let unitsAvail = 0;
      if (this.$route.name === 'FloorplanList') {
        unitsAvail = this.availUnits;
      } else {
        unitsAvail = this.availUnitsByPlanId(this.$route.params.id);
      }
      return unitsAvail;
    }
  }
};
</script>

<style lang="scss">
#scale-model {
  background-color: #bceffa;
  .bg-blue {
    background-color: rgba(189, 239, 250, 0.5);
  }

  .bg-green {
    background-color: hsl(164, 39%, 89%);
  }
  iframe {
    transition: opacity 0.2s ease-out;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/ScaleModel.vue